import React from 'react';
import AmountFormatter from '../../components/customComponent/customTable/tableFormat/amountFormatter';
import DateFormatter from '../../components/customComponent/customTable/tableFormat/dateFormatter';
// import TableFormatter from '../../components/customComponent/customTable/tableFormat/tableFormatter';
import TxnPeriodFormatter from '../../components/customComponent/customTable/tableFormat/txnPeriodFormatter';
import TableStatusUI from '../../components/customComponent/customTable/tableFormat/tableStatusUI';
import MerchantFormatter from '../../components/customComponent/customTable/tableFormat/merchantFormatter';
// import UserRoleFormatter from '../../components/customComponent/customTable/tableFormat/userRoleFormatter';
import PhoneNoFormatter from '../../components/customComponent/customTable/tableFormat/phoneNoFormatter';
// import TxnTypeFormatter from '../../components/customComponent/customTable/tableFormat/txnTypeFormatter';
import FileAttachment from '../../components/customComponent/customTable/tableFormat/attachmentFormatter';
import StatusFormatter from '../../components/customComponent/customTable/tableFormat/statusFormatter';
import LinkFormatter from '../../components/customComponent/customTable/tableFormat/linkFormatter';
import CopyToClipBoard from '../copyToClipboard';
// import Popup from '@techsoftware/happay-widgets/Popup';

const tableConfig = {
  invoiceVendorHeader: {
    '/invoice/myinvoice': {
      header: [
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell || ''} />
          ),
        },
        {
          Header: 'Status',
          dataField: 'approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          primarySortKeyInDataField: 'invoice_id',
          nestedKey: 'name',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt} isBlocked={row.is_blocked} />;
          },
        },
        {
          Header: 'Vendor Name',
          dataField: 'display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => (
            <LinkFormatter
              data={row?.display_name}
              createdBy={row['vendor_details.created_by']}
              containerType={row['vendor_details.container_type']}
              id={row['vendor_details.vendor_id']}
            />
          ),
        },
        {
          Header: 'Invoice Date',
          dataField: 'invoice_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell || ''} />
          ),
        },
        {
          Header: 'Invoice ID',
          dataField: 'invoice_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          className: 'overflow-visible',
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => (
            <CopyToClipBoard text={row?.invoice_ref_id || ''} />
          ),
        },
        {
          Header: 'UTR',
          dataField: 'utr',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => <CopyToClipBoard text={row?.utr || '--'} />,
        },
        {
          Header: 'Attachment',
          dataField: 'attachments',
          field_type: 'number',
          disableDragDrop: true,
          // dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => (
            <FileAttachment row={row} data={cell || ''} />
          ),
        },
        {
          Header: 'Payable Amount',
          dataField: 'final_amount',
          field_type: 'number',
          dataAlign: 'right',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            const dt = {
              amount: cell,
              currency: row.currency,
            };
            return <AmountFormatter data={dt} />;
          },
        },
        // {
        //   Header: 'Approved Amount',
        //   dataField: 'approved_amount',
        //   field_type: 'number',
        //   dataAlign: 'right',
        //   disableDragDrop: true,
        //   dataSort: true,
        //   width: undefined,
        //   primarySortKeyInDataField: 'invoice_id',
        //   Cell: (cell, col, row) => (
        //     <AmountFormatter row={row} data={cell || ''} item="Amount" />
        //   ),
        // },
      ],
      actions: { edit: 'Edit', view: 'View', delete: 'Delete' },
      defaultColumn: [
        'created_on',
        'approval_status.name',
        'display_name',
        'invoice_date',
        'invoice_id',
        'attachments',
        'final_amount',
        // 'approved_amount',
      ],
    },
    '/invoice/myapproval': {
      header: [
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'resource_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Created By',
          dataField: 'requestor.name',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          nestedKey: 'name',
          primarySortKeyInDataField: 'resource_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'Status',
          dataField: 'object_data.approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          nestedKey: 'name',
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'name',
          width: 200,
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['object_data.approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt} isBlocked={row.is_blocked} />;
          },
        },
        {
          Header: 'Vendor Name',
          dataField: 'object_data.vendor_details.display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'display_name',
          Cell: (cell, col, row) => (
            <LinkFormatter
              data={cell}
              createdBy={row['object_data.vendor_details.created_by']}
              containerType={row['object_data.vendor_details.container_type']}
              id={row['object_data.vendor_details.vendor_id']}
            />
          ),
        },
        {
          Header: 'Invoice Date',
          dataField: 'object_data.invoice_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'invoice_date',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Payment Scheduled Date',
          dataField: 'object_data.payment_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 250,
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'payment_date',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Payment Date',
          dataField: 'object_data.due_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'due_date',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Invoice ID',
          dataField: 'object_data.invoice_ref_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          className: 'overflow-visible',
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'invoice_ref_id',
          Cell: (cell, col, row) => <CopyToClipBoard text={cell} />,
        },
        {
          Header: 'UTR',
          dataField: 'utr',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => <CopyToClipBoard text={row?.utr || '--'} />,
        },
        {
          Header: 'Attachment',
          dataField: 'object_data.attachments',
          field_type: 'number',
          disableDragDrop: true,
          // dataSort: false,
          width: 150,
          Cell: (cell, col, row) => <FileAttachment row={row} data={cell} />,
        },
        {
          Header: 'Payable Amount',
          dataField: 'object_data.final_amount',
          field_type: 'number',
          dataAlign: 'right',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          primarySortKeyInDataField: 'resource_id',
          nestedKey: 'final_amount',
          Cell: (cell, col, row) => {
            const dt = {
              amount: cell,
              currency: row['object_data.currency'],
            };
            return <AmountFormatter data={dt} />;
          },
        },
        // {
        //   Header: 'Approved Amount',
        //   dataField: 'approved_amount',
        //   field_type: 'number',
        //   dataAlign: 'right',
        //   disableDragDrop: true,
        //   dataSort: true,
        //   width: undefined,
        //   primarySortKeyInDataField: 'resource_id',
        //   Cell: (cell, col, row) => {
        //     let eleData = row?.object_data?.approved_amount || '';
        //     return <AmountFormatter row={row} data={eleData} item="Amount" />;
        //   },
        // },
      ],
      actions: { view: 'View' },
      primaryKey: 'resource_id',
      defaultColumn: [
        'created_on',
        'requestor.name',
        'object_data.approval_status.name',
        'object_data.vendor_details.display_name',
        'object_data.invoice_date',
        'object_data.payment_date',
        'object_data.due_date',
        'object_data.invoice_ref_id',
        'object_data.attachments',
        'object_data.final_amount',
        'resource_id',
        // 'approved_amount',
      ],
      col_option: ['amount_breakdown'],
    },
    '/vendor/myvendor': {
      header: [
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell || ''} />
          ),
        },
        {
          Header: 'Status',
          dataField: 'approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          nestedKey: 'name',
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt || ''} />;
          },
        },
        {
          Header: 'Vendor Name',
          dataField: 'display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => <div>{row?.display_name || ''}</div>,
        },
        {
          Header: 'GSTIN',
          dataField: 'identification_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          className: 'overflow-visible',
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => (
            <CopyToClipBoard text={row?.identification_id || ''} />
          ),
        },
        {
          Header: 'City',
          dataField: 'city',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => <div>{row?.city || ''}</div>,
        },
        {
          Header: 'State',
          dataField: 'state',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => <div>{row?.state || ''}</div>,
        },
        {
          Header: 'Contact Number',
          dataField: 'mobile_number',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => {
            const dt = {
              mobile_number: cell,
              mobile_extension: row['object_data.mobile_extension'],
            };
            return <PhoneNoFormatter data={dt || ''} />;
          },
        },
        {
          Header: 'Email ID',
          dataField: 'email_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'identification_id',
          Cell: (cell, col, row) => <div>{row?.email_id || ''}</div>,
        },
      ],
      actions: { edit: 'Edit', view: 'View', delete: 'Delete' },
      defaultColumn: [
        'created_on',
        'approval_status.name',
        'display_name',
        'identification_id',
        'city',
        'state',
        'mobile_number',
        'email_id',
      ],
    },
    '/vendor/myapproval': {
      header: [
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Created By',
          dataField: 'requestor.name',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          nestedKey: 'name',
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'Status',
          dataField: 'object_data.approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          nestedKey: 'name',
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['object_data.approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt} />;
          },
        },
        {
          Header: 'Vendor Name',
          dataField: 'object_data.display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'GSTIN',
          dataField: 'object_data.identification_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          className: 'overflow-visible',
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <CopyToClipBoard text={cell} />,
        },
        {
          Header: 'City',
          dataField: 'object_data.city',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'State',
          dataField: 'object_data.state',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'Contact Number',
          dataField: 'object_data.mobile_number',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => {
            const dt = {
              mobile_number: cell,
              mobile_extension: row['object_data.mobile_extension'],
            };
            return <PhoneNoFormatter data={dt} />;
          },
        },
        {
          Header: 'Email ID',
          dataField: 'object_data.email_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
      ],
      actions: { view: 'View' },
      col_option: ['object_data'],
      defaultColumn: [
        'created_on',
        'requestor.name',
        'object_data.approval_status.name',
        'object_data.display_name',
        'object_data.identification_id',
        'object_data.city',
        'object_data.state',
        'object_data.mobile_number',
        'object_data.email_id',
      ],
    },
    dashboardAdminInvoice: {
      header: [
        {
          Header: 'Vendor Name',
          dataField: 'object_data.vendor_details.display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          primarySortKeyInDataField: 'twf_id',
          width: 150,
          Cell: (cell, col, row) => (
            <LinkFormatter
              data={cell}
              createdBy={row['object_data.vendor_details.created_by']}
              containerType={row['object_data.vendor_details.container_type']}
              id={row['object_data.vendor_details.vendor_id']}
            />
          ),
        },
        {
          Header: 'Invoice Amount',
          dataField: 'object_data.approved_amount',
          field_type: 'number',
          dataAlign: 'right',
          disableDragDrop: true,
          // dataSort: true,
          width: 180,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => {
            const amount =
              +row?.['object_data.approved_amount'] != 0
                ? row?.['object_data.approved_amount']
                : row?.['object_data.payable_amount'];
            // let eleData =
            //   obj?.approved_amount != 0
            //     ? obj?.approved_amount
            //     : obj?.payable_amount || '';
            // return <div>{eleData}</div>
            const dt = {
              amount,
              currency: row['object_data.currency'],
            };
            return <AmountFormatter data={dt} />;
          },
        },
        // {
        //   Header: 'Payment date',
        //   dataField: 'object_data',
        //   field_type: 'date',
        //   disableDragDrop: true,
        //   dataSort: true,
        //   width: 150,
        //   Cell: (cell, col, row) => {
        //     let eleData = cell?.due_date || '';
        //     return <DateFormatter type="date_without_time" data={eleData} />;
        //   },
        // },
        // {
        //   Header: 'Payable amount',
        //   dataField: 'object_data',
        //   field_type: 'number',
        //   disableDragDrop: true,
        //   dataSort: true,
        //   width: 130,
        //   Cell: (cell, col, row) => {
        //     let eleData = cell?.payable_amount || '';
        //     return <AmountFormatter row={row} data={eleData} item="Amount" />;
        //   },
        // },
        {
          Header: 'Payment Scheduled Date',
          dataField: 'object_data.payment_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 250,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Status',
          dataField: 'object_data.approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['object_data.approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt} isBlocked={row.is_blocked} />;
          },
        },
        {
          Header: 'Created On',
          dataField: 'object_data.created_on',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 160,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Created By',
          dataField: 'requestor.name',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
      ],
      actions: { view: 'View' },
    },
    dashboardAdminVendor: {
      header: [
        {
          Header: 'Vendor Name',
          dataField: 'object_data.display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell || ''}</div>,
        },
        {
          Header: 'GSTIN',
          dataField: 'object_data.identification_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          className: 'overflow-visible',
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <CopyToClipBoard text={cell || ''} />,
        },
        {
          Header: 'City',
          dataField: 'object_data.city',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'Email ID',
          dataField: 'object_data.email_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },

        {
          Header: 'Created By',
          dataField: 'requestor.name',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => <div>{cell}</div>,
        },
        {
          Header: 'Created On',
          dataField: 'object_data.created_on',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 140,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell} />
          ),
        },
        {
          Header: 'Status',
          dataField: 'object_data.approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 180,
          primarySortKeyInDataField: 'twf_id',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['object_data.approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt} />;
          },
        },
      ],
      actions: { view: 'View' },
    },
    dashboardUserInvoice: {
      header: [
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            const eleData = row?.created_on || '';
            return <DateFormatter type="date_without_time" data={eleData} />;
          },
        },
        {
          Header: 'Vendor Name',
          dataField: 'display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            const eleData = row?.display_name || '';
            return <div>{eleData}</div>;
          },
        },
        {
          Header: 'Payment Scheduled Date',
          dataField: 'payment_date',
          field_type: 'date',
          disableDragDrop: true,
          dataSort: true,
          width: 150,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            const eleData = row?.payment_date || '';
            return <DateFormatter type="date_without_time" data={eleData} />;
          },
        },
        {
          Header: 'Invoice Amount',
          dataField: 'approved_amount',
          dataAlign: 'right',
          field_type: 'number',
          disableDragDrop: true,
          // dataSort: true,
          width: 130,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            // let eleData =
            //   row?.approved_amount != 0
            //     ? row?.approved_amount || ''
            //     : row?.payable_amount || '';
            const dt = {
              amount:
                row?.approved_amount != 0
                  ? row?.approved_amount || ''
                  : row?.payable_amount || '',
              currency: row.currency,
            };
            return <AmountFormatter data={dt} />;
          },
        },
        {
          Header: 'Status',
          dataField: 'approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          primarySortKeyInDataField: 'invoice_id',
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['approval_status.color_code'],
              name: cell,
            };
            // let eleData = row?.approval_status || {};
            return <StatusFormatter data={dt} />;
          },
        },
      ],
      actions: { view: 'View' },
    },
    dashboardUserVendor: {
      header: [
        {
          Header: 'Vendor Name',
          dataField: 'display_name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          Cell: (cell, col, row) => <div>{row?.display_name || ''}</div>,
        },
        {
          Header: 'GSTIN',
          dataField: 'identification_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          Cell: (cell, col, row) => <div>{row?.identification_id || ''}</div>,
        },
        {
          Header: 'City',
          dataField: 'city',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          Cell: (cell, col, row) => <div>{row?.city || ''}</div>,
        },
        {
          Header: 'Email ID',
          dataField: 'email_id',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          Cell: (cell, col, row) => <div>{row?.email_id || ''}</div>,
        },
        {
          Header: 'Status',
          dataField: 'approval_status.name',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: 200,
          Cell: (cell, col, row) => {
            const dt = {
              color_code: row['approval_status.color_code'],
              name: cell,
            };
            return <StatusFormatter data={dt || ''} />;
          },
        },
        {
          Header: 'Created On',
          dataField: 'created_on',
          field_type: 'text',
          disableDragDrop: true,
          dataSort: true,
          width: undefined,
          Cell: (cell, col, row) => (
            <DateFormatter type="date_without_time" data={cell || ''} />
          ),
        },
      ],
      actions: { view: 'View' },
    },
    paid_date: {
      Header: 'Payment Date',
      dataField: 'payment_date',
      field_type: 'date',
      disableDragDrop: true,
      dataSort: true,
      width: undefined,
      Cell: (cell, col, row) => (
        <DateFormatter type="date_without_time" data={cell || ''} />
      ),
    },
  },
  previousBalance: {
    header: [
      {
        Header: 'Due date',
        dataField: 'grace_period_end_date',
        field_type: 'date',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <DateFormatter type="date_without_time" data={cell || ''} />
        ),
      },
      {
        Header: 'Transaction period',
        dataField: 'from_date',
        field_type: '',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <TxnPeriodFormatter row={row} data={cell || ''} />
        ),
      },
      {
        Header: 'Total payable',
        dataField: 'net_payable',
        field_type: 'number',
        dataAlign: 'right',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          const dt = {
            amount: cell,
          };
          return <AmountFormatter data={dt || {}} />;
        },
      },
      {
        Header: 'Paid till now',
        dataField: 'total_paid',
        field_type: 'number',
        dataAlign: 'right',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          const dt = {
            amount: cell,
          };
          return <AmountFormatter data={dt} />;
        },
      },
      {
        Header: 'Status',
        dataField: 'status',
        field_type: '',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          let notCleared = false;
          // const data = cell;
          if (cell === 'generated' && row.net_payable) {
            notCleared = true;
          } else if (cell === 'carried_over' && row.balance > 10) {
            notCleared = true;
          }
          return (
            <TableStatusUI
              data={cell || ''}
              notCleared={notCleared}
              type="status"
            />
          );
        },
      },
    ],
    actions: { view: 'View' },
    col_option: [
      'to_date',
      'id',
      'grace_period_end_date',
      'from_date',
      'net_payable',
      'total_paid',
      'balance',
    ],
  },
  payments: {
    // header: {
    //   'Payment date': { key: 'payment_date', type: 'date_without_time' },
    //   'Ref ID': { key: 'utr', type: 'text' },
    //   Amount: { key: 'amount', type: 'amount' },
    //   Status: { key: 'status_display', type: 'text' },
    // },
    header: [
      {
        Header: 'Payment date',
        dataField: 'payment_date',
        field_type: 'date',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <DateFormatter type="date_without_time" data={cell || ''} />
        ),
      },
      {
        Header: 'Ref ID',
        dataField: 'utr',
        field_type: 'text',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => <span>{cell || ''}</span>,
      },
      {
        Header: 'Amount',
        dataField: 'amount',
        field_type: 'number',
        dataAlign: 'right',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          const dt = {
            amount: cell,
          };
          return <AmountFormatter data={dt || ''} />;
        },
      },
      {
        Header: 'Status',
        dataField: 'status_display',
        field_type: 'text',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => <span>{cell || ''}</span>,
      },
    ],
    actions: { view: 'View' },
  },
  billTxn: {
    // header: {
    //   'Transaction date time': { key: 'created_at', type: 'date' },
    //   User: { key: 'user_name', type: 'text' },
    //   Merchant: { key: 'gmr', type: 'merchant' },
    //   Amount: { key: 'amount', type: 'amount' },
    // },
    header: [
      {
        Header: 'Transaction date time',
        dataField: 'created_at',
        field_type: 'date',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <DateFormatter type="date" data={cell || ''} />
        ),
      },
      {
        Header: 'User',
        dataField: 'user_name',
        field_type: 'text',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => <span>{cell || ''}</span>,
      },
      {
        Header: 'Merchant',
        dataField: 'gmr',
        field_type: '',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <MerchantFormatter type="merchant" row={row} data={cell.name} />
        ),
      },
      {
        Header: 'Amount',
        dataField: 'amount',
        field_type: 'number',
        dataAlign: 'right',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          const dt = {
            amount: cell,
            txn_type_debit_type: row?.txn_type_debit_type,
          };
          return <AmountFormatter data={dt || ''} />;
        },
      },
    ],
    actions: { view: 'View' },
    col_option: [
      'credit_transaction_id',
      'created_at',
      'user_name',
      'gmr',
      'txn_type_debit_type',
    ],
  },
  billPenalty: {
    // header: {
    //   'Penalty date': { key: 'created_at', type: 'date' },
    //   'Penalty ID': { key: 'credit_transaction_id', type: 'text' },
    //   'Penalty amount': { key: 'amount', type: 'amount' },
    //   Reason: { key: 'type', type: 'text' },
    // },
    header: [
      {
        Header: 'Due date',
        dataField: 'created_at',
        field_type: 'date',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => (
          <DateFormatter type="date" data={cell || ''} />
        ),
      },
      {
        Header: 'Penalty ID',
        dataField: 'credit_transaction_id',
        field_type: 'text',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => <span>{cell || ''}</span>,
      },
      {
        Header: 'Penalty amount',
        dataField: 'amount',
        field_type: 'number',
        dataAlign: 'right',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => {
          const dt = {
            amount: cell,
          };
          return <AmountFormatter data={dt || ''} />;
        },
      },
      {
        Header: 'Reason',
        dataField: 'type',
        field_type: 'text',
        disableDragDrop: true,
        dataSort: true,
        width: undefined,
        primarySortKeyInDataField: 'id',
        Cell: (cell, col, row) => <span>{cell || ''}</span>,
      },
    ],
    actions: { view: 'View' },
    col_option: ['credit_transaction_id'],
  },
};

export default tableConfig;
